<template>
  <div class="home">
    <h1>rawrke's site</h1>
    <p>🚧<i>work in progress</i></p>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style>
.home {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
h1 {
  border-bottom: 3px double #3e4750;
  display: inline-flex;
  padding-bottom: 5px;
  height:auto;
}
</style>
